import Container from '@/layouts/Container';
import Header from '@/layouts/Header';
import Home from '@/components/Home';
import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CustomerExperience } from '@/components/Home/CustomerExperience';
import { KnowledgeBase } from '@/components/Home/KnowledgeBase';
import { Function } from '@/components/Home/Function';
import { Voice } from '@/components/Home/Voice';
import { Canvas } from '@/components/Home/Canvas';
import Price from '@/components/Price';
import ContactPage from '@/components/Contact';
import Contact from '@/layouts/Contact';
import Footer from '@/layouts/Footer';
import { AccountCenter } from '@mygpt/app';
import { useGPTStore } from '@/store';

const MainLayout = () => {
  const [pageHasBg, setPageHasBg] = useState(false);
  const { pathname } = useLocation();
  const { paymentInfo } = useGPTStore();

  useLayoutEffect(() => {
    switch (pathname) {
      case '/':
        setPageHasBg(true);
        break;
      default:
        setPageHasBg(false);
    }
  }, [pathname]);
  return (
    <div className={`grid`}>
      <Header />
      {!pageHasBg ? (
        pathname === '/price' ? (
          <Price />
        ) : pathname === '/contact' ? (
          <ContactPage />
        ) : pathname === '/account' ? (
          <div className="pt-20">
            <AccountCenter paymentInfo={paymentInfo} />
          </div>
        ) : (
          <Container />
        )
      ) : (
        <div className="mt-20">
          <Home />
          <CustomerExperience />
          <KnowledgeBase />
          <Function />
          <Voice />
          <Canvas />
        </div>
      )}
      <Contact />
      <Footer />
    </div>
  );
};

export default MainLayout;
